import { render, staticRenderFns } from "./ModalAlterarConsentimento.vue?vue&type=template&id=343cabca&scoped=true"
import script from "./ModalAlterarConsentimento.vue?vue&type=script&lang=js"
export * from "./ModalAlterarConsentimento.vue?vue&type=script&lang=js"
import style0 from "./ModalAlterarConsentimento.vue?vue&type=style&index=0&id=343cabca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343cabca",
  null
  
)

export default component.exports